import { Emitter } from "@core/events/emitter";

export interface HoverChangedEvent {
  readonly snapshotId: string | null;
}

export interface IHoverModel {
  readonly onChanged: Emitter<HoverChangedEvent>;
  readonly hoveredId: string | null;
  setHovered(snapshotId: string | null): void;
  clear(): void;
}

export const HOVER_MODEL = Symbol.for("Campfire.HoverModel");
